import { setupDayjs } from './setup-dayjs';

export async function bootstrap() {
  setupDayjs();
}
